import React from 'react';
import { formatCurrency, getAlert } from '../../../../utils/SamuiUtils';
import Swal from 'sweetalert2';
import { formatThaiDateUi } from '../../../../utils/DateUtils';
export default React.memo(function DataTable({
  fields,
  data,
  onSort,
  sortField,
  sortOrder,
  onRowClick,
  sums,
  onEdit,
}) {
  return (
    <div className='card p-2'>
      <div
        className='table-responsive'
        style={{ height: '70vh', overflowY: 'auto' }}
      >
        <table className='table table-striped table-hover'>
          <thead className='thead-dark'>
            <tr>
              {fields.map((f) => (
                <th
                  key={f.key}
                  style={{
                    width: f.w,
                    cursor: f.sortable ? 'pointer' : 'default',
                  }}
                  className={`text-${f.alignHeader} text-nowrap`}
                  onClick={() => f.sortable && onSort(f.key)}
                >
                  {f.label}
                  {f.sortable && (
                    <span className='ms-1'>
                      {f.key === sortField ? (
                        sortOrder === 'asc' ? (
                          <i className='fas fa-sort-up text-white'></i>
                        ) : (
                          <i className='fas fa-sort-down text-white'></i>
                        )
                      ) : (
                        <i
                          className='fas fa-sort text-muted'
                          style={{ opacity: 0.5 }}
                        ></i>
                      )}
                    </span>
                  )}
                </th>
              ))}
              <th className='text-center' style={{ width: '2%' }}>
                รูป
              </th>
              <th className='text-center' style={{ width: '2%' }}>
                แก้ไข
              </th>
              <th className='text-center' style={{ width: '2%' }}>
                ลิงค์
              </th>
            </tr>
          </thead>
          <tbody>
            {data.length ? (
              data.map((item, i) => (
                <tr
                  key={i}
                  style={{ cursor: 'pointer' }}
                  onClick={() => onRowClick(i)}
                >
                  {fields.map((f) => (
                    <td key={f.key} className={`text-${f.align}`}>
                      {f.key === 'job_date' || f.key === 'srv_date'
                        ? formatThaiDateUi(item[f.key])
                        : f.numeric
                        ? formatCurrency(item[f.key])
                        : item[f.key] || '-'}
                    </td>
                  ))}
                  <td className="text-center">
                    {item.images?.length > 0 && (
                      <button
                        className="btn btn-sm btn-info"
                        onClick={(e) => {
                          e.stopPropagation();
                          const images = item.images;
                          const htmlContent = `
            <div style="display: grid; grid-template-columns: repeat(3, 1fr); gap: 10px;">
              ${images
                              .map(
                                (src) => `
                    <a href="${src}" target="_blank" style="display:block;">
                      <img 
                        src="${src}" 
                        style="width: 100%; border-radius: 8px; object-fit: cover; aspect-ratio: 1/1;"
                      />
                    </a>
                  `
                              )
                              .join('')}
            </div>
          `;
                          Swal.fire({
                            title: `รูปภาพทั้งหมด (${images.length})`,
                            html: htmlContent,
                            width: 500,
                            confirmButtonText: 'ปิด',
                          });
                        }}
                      >
                        <i className="fas fa-image text-white"></i>
                      </button>
                    )}
                  </td>

                  <td className='text-center'>
                    <button
                      className='btn btn-sm btn-warning'
                      onClick={(e) => {
                        e.stopPropagation();
                        onEdit?.(item);
                      }}
                    >
                      <i className='fas fa-edit text-white'></i>
                    </button>
                  </td>
                  <td className='text-center'>
                    <button
                      className='btn btn-sm btn-primary'
                      onClick={(e) => {
                        e.stopPropagation();
                        const url = `${window.location.origin}/service/${item.job_id}/${item.job_time}`;
                        navigator.clipboard
                          .writeText(url)
                          .then(() => {
                            Swal.fire({
                              icon: 'success',
                              title: 'คัดลอกลิงก์สำเร็จ',
                              text: 'ลิงก์ถูกคัดลอกไปยังคลิปบอร์ดแล้ว',
                              confirmButtonText: 'เปิดลิงก์',
                              showCancelButton: true,
                              cancelButtonText: 'ปิด',
                            }).then((result) => {
                              if (result.isConfirmed) {
                                window.open(url, '_blank');
                              }
                            });
                          })
                          .catch((err) =>
                            getAlert(
                              'FAILED',
                              'ไม่สามารถคัดลอกลิงก์ได้: ' + err.message
                            )
                          );
                      }}
                    >
                      <i className='fas fa-copy'></i>
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={fields.length + 2}>
                  <center>
                    <h5>ไม่พบข้อมูล</h5>
                  </center>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
});
